import mammoth from 'mammoth';

import Spec, { SpecData } from '../models/Spec';

export interface DocumentTableDataTypes {
  name: string;
  tables: RegExpMatchArray;
  code: string;
  spec: string;
}

export interface DocumentTablesTypes {
  title: string;
  data: DocumentTableDataTypes[];
}

export const filterExcerciseName = (
  md: any
): { filtered: string[]; raw: string[] } => {
  const excerciseNameFiltered: string[] = [];
  const excerciseNameFilteredRaw: string[] = [];
  // let cleanMD = md.value.replace(
  //   /\n#+ Output\n|\n#+ Input\n|#+ Examples*|_*Examples*_*\n|\n#+ Constraints\n|#* *What to submit\? +\n|_+What to submit\?_+|#* *Hints *\n|_*Hints_*/g,
  //   ""
  // );
  let excerciseName = md.value.match(
    /\n\n## ([^<>]*?)\n\n|\n\n\d\. *__([^<>]*?)__\n\n/g
  );
  if (excerciseName == null) {
    let top = md.value.match(/\b([^]*?)\n\n/);
    excerciseName = [top[0]];
  }
  excerciseName.forEach((ex: any, i: number) => {
    excerciseNameFilteredRaw.push(ex.replace(/\d\.|#|_*/g, '').trim());
    ex = ex.replace(/__|#|[.]|\\|\*|"|\//g, '').trim();
    ex = ex
      .replaceAll(/[\s-]+/g, '-')
      .toUpperCase()
      .replace(/^\d+-/g, '');
    excerciseNameFiltered.push(ex);
  });
  return { filtered: excerciseNameFiltered, raw: excerciseNameFilteredRaw };
};

export const reformatTable = (tables: RegExpMatchArray, i: number) => {
  let newTables: string[] = [];
  // const test = "abc";
  if (!tables) {
    return [];
  }
  tables.forEach((tableHtml, j) => {
    let tr = tableHtml.match(/<tr([^]*?)\/tr>/g);
    let ifValidTable = tableHtml.match(/Input|Output|Comment|Explanation/g);
    if (tr) {
      let headerCount: number;
      let indexOfOutput: number | null;
      tr.forEach((val, k) => {
        if (val.match(/Input|Output|Comment|Explanation/g)) {
          let newVal = val.replace(
            /<td contenteditable="true"([^]*?)>/g,
            '<td>'
          );
          tableHtml = tableHtml.replace(val, newVal);
        }
        let td = val.match(/<td([^]*?)\/td>/g);
        if (td) {
          td.forEach((thead, i) => {
            if (thead.match(/Output/g)) {
              indexOfOutput = i;
            }
          });
        }
        // making sure td length are equal
        if (td && k === 0) {
          headerCount = td.length;
        }
        if (td && headerCount && td.length !== headerCount && indexOfOutput) {
          for (let u = td.length; u < headerCount; u++) {
            td.splice(indexOfOutput, 1, '<td></td>');
          }
          let newVal = val.replace(val, td.join('')); // adding empty td if td length is not equal
          tableHtml = tableHtml.replace(val, newVal);
          indexOfOutput = null;
        }
        if (td && headerCount && td.length !== headerCount) {
          for (let u = td.length; u < headerCount; u++) {
            if (indexOfOutput !== null) {
              td.splice(indexOfOutput, 1, '<td></td>');
            }
          }
          let newVal = val.replace(/<td /g, '<td colspan="5"'); //full td width if td length is not equal
          tableHtml = tableHtml.replace(val, newVal);
        }
        //end
        if (
          td &&
          val.match(/Input|Output|Comment|Explanation/g) === null &&
          ifValidTable !== null
        ) {
          td.forEach((val, l) => {
            if (l % 2 === 0 && td !== null) {
              if (td.length % 2 !== 0) {
                if (l === td.length - 1) return;
              }
              let newVal = val.replace(
                /<td([^]*?)>/g,
                `<td class="input-td" id="${i}-${j}" contenteditable="true">`
              );
              tableHtml = tableHtml.replace(val, newVal);
            } else {
              let newVal = val.replace(
                /<td([^]*?)>/g,
                `<td id="${i}-${j}" contenteditable="true">`
              );
              tableHtml = tableHtml.replace(val, newVal);
            }
          });
        }
      });
    }
    newTables.push(tableHtml);
  });
  return newTables;
};

export const getTablesFromDocument = async (
  file: File
): Promise<DocumentTablesTypes> => {
  const arrayBuffer = await file.arrayBuffer();
  let data = [];
  let html = await mammoth.convertToHtml({ arrayBuffer: arrayBuffer });
  let md = await mammoth.convertToMarkdown({ arrayBuffer: arrayBuffer });

  let excercises = filterExcerciseName(md);

  for (let i = 1; i <= excercises.raw.length; i++) {
    let matched;
    let otherFormat = `<strong>${excercises.raw[i - 1].replace(
      / /g,
      '</strong> <strong>'
    )}</strong>`;
    if (i === excercises.raw.length) {
      let relast = new RegExp(
        `(${excercises.raw[i - 1]}|${otherFormat})([^]*?)$`,
        'g'
      );
      matched = html.value.match(relast);
    } else {
      let otherFormatEnd = `<strong>${excercises.raw[i].replace(
        / /g,
        '</strong> <strong>'
      )}</strong>`;
      let re = new RegExp(
        `(${excercises.raw[i - 1]}|${otherFormat})([^]*?)(${
          excercises.raw[i]
        }|${otherFormatEnd})`,
        'g'
      );
      matched = html.value.match(re);
    }
    if (matched) {
      let cleanTable = matched[0]
        .replace(
          /<td colspan="\d"><\/td>|<td rowspan="\d"><\/td>|<td><\/td>|<tr><\/tr>/g,
          ''
        )
        .replace(/<td([^]*?)>/g, '<td contenteditable="true">');
      let tables: RegExpMatchArray = cleanTable.match(/<table([^]*?)\/table>/g);
      tables = reformatTable(tables, i - 1);
      data[i - 1] = {
        name: excercises.filtered[i - 1].replace(/\\/g, ''),
        tables,
        code: '',
        spec: '',
      };
    } else {
      data[i - 1] = {
        name: excercises.filtered[i - 1].replace(/\\/g, ''),
        tables: [],
        code: '',
        spec: '',
      };
    }
  }

  return { title: file.name.replace(/.docx|.doc/gi, ''), data };
};

export const convertTablesToSpec = (
  tables: RegExpMatchArray
): Partial<Spec> => {
  let data = [];

  for (let i = 0; i < tables.length; i++) {
    let table = tables[i];
    let rows = table.match(/<tr([^]*?)\/tr>/g);
    let validRow = true;
    if (!!rows) {
      for (let r = 0; r < rows.length; r++) {
        if (
          rows[r].match(/Input|Output|Comments|Comment|Explanation/g) ===
            null &&
          validRow
        ) {
          let cells = rows[r].match(/<td([^]*?)\/td>/g);
          let d: SpecData = { arguments: [], mainInvoker: '', output: '' };
          for (let c = 0; cells && c < cells.length; c++) {
            let value = cells[c]
              .replace(/<br>|<\/br>|<\/p>|<\/div>/g, '\n')
              .replace(/<([^]*?)>/g, '')
              .trim()
              .replace(/\n$/g, '');
            if (cells.length % 2 !== 0) {
              if (c === cells.length - 1) break;
            }
            if (c % 2 === 0) {
              value = value.replace(/\n/g, '');
              d.arguments = [value];
              d.mainInvoker = `main(${value})`;
            }
            if (c % 2 === 1) {
              d.output = value;
              data.push(d);
              d = { arguments: [], mainInvoker: '', output: '' };
            }
          }
        }
      }
    }
  }

  let spec: Partial<Spec> = {
    env: 'node',
    entry: 'argv',
    data,
  };

  return spec;
};
